/*
 * File Path: client/src/api/propertyService.js
 * Description: Service functions for managing properties (CRUD) and property sharing.
 * Developed by: M. YOUCEF Yazid (yazid.youcef@gmail.com)
 * Version: 1.2.0
 * CreateDate: 2025-05-01
 * UpdateDate: 2025-06-17
 */

import { apiClient, handleApiError } from './apiClient';

// --- NEW Function to Fetch Devices for a Property ---
/**
 * Fetches all devices associated with a specific property ID.
 * @param {number|string} propertyId - The ID of the property.
 * @returns {Promise<Array<object>>} Array of device objects.
 * @throws {Error} Custom error on failure.
 */
export const fetchDevicesForProperty = async (propertyId) => {
    try {
        // Endpoint: GET /api/auth/properties/:id/devices
        const response = await apiClient.get(`/auth/properties/${propertyId}/devices`);
        return response.data;
    } catch (error) {
        handleApiError(error);
    }
};


// --- Property CRUD ---
export const addProperty = async (payload) => {
    try {
        const response = await apiClient.post('/auth/properties', payload);
        return response.data;
    } catch (error) {
        handleApiError(error);
    }
};

export const fetchProperties = async () => {
    try {
        const response = await apiClient.get('/auth/properties');
        return response.data;
    } catch (error) {
        handleApiError(error);
    }
};

export const updateProperty = async (id, payload) => {
    try {
        const response = await apiClient.put(`/auth/properties/${id}`, payload);
        return response.data;
    } catch (error) {
        handleApiError(error);
    }
};

export const deleteProperty = async (id) => {
    try {
        const response = await apiClient.delete(`/auth/properties/${id}`);
        return response.data;
    } catch (error) {
        handleApiError(error);
    }
};

// --- Property Names ---
export const fetchOwnedPropertyNames = async () => {
    try {
        const response = await apiClient.get('/auth/properties/names');
        return response.data;
    } catch (error) {
        handleApiError(error);
    }
};

export const fetchSharedPropertyNames = async () => {
    try {
        const response = await apiClient.get('/auth/properties/shared/names');
        return response.data;
    } catch (error) {
        handleApiError(error);
    }
};

export const fetchEditableProperties = async () => {
    try {
        const response = await apiClient.get('/auth/properties/editable');
        return response.data;
    } catch (error) {
        handleApiError(error);
    }
};

// --- Property Sharing ---
export const fetchSharesForProperty = async (propertyId) => {
    try {
        const response = await apiClient.get(`/auth/properties/${propertyId}/shares`);
        return response.data;
    } catch (error) {
        handleApiError(error);
    }
};

export const shareProperty = async (propertyId, userIdToShareWith, permissions) => {
    try {
        const payload = { shared_with_user_id: userIdToShareWith, permissions: permissions };
        const response = await apiClient.post(`/auth/properties/${propertyId}/shares`, payload);
        return response.data;
    } catch (error) {
        handleApiError(error);
    }
};

export const deleteShare = async (shareId) => {
     try {
        const response = await apiClient.delete(`/auth/properties/shares/${shareId}`);
        return response.data;
    } catch (error) {
        handleApiError(error);
    }
};

export const leaveShare = async (propertyId) => {
    try {
        const response = await apiClient.delete(`/auth/properties/${propertyId}/shares/me`);
        return response.data;
    } catch (error) {
        handleApiError(error);
    }
};
